import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import Dsar from '../bigProjects/Dsar';

// COMPLIANCE (CCPA/CPRA): the DSAR admin queue is a GENERAL consumer-privacy
// obligation, NOT a Large Projects feature — any user can file a DSAR at
// /data-rights. So this screen must be reachable regardless of the Large
// Projects flag. We intentionally do NOT gate on `largeProjectsEnabled` here.
// Still admin-only (requireAdmin via isAdminAuthenticated + per-resolver guards
// on the api side). The other big-projects/* routes keep their LP gate.
async function action({ store }) {
  const isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;

  if (!isAdminAuthenticated) {
    return { redirect: '/login' };
  }

  return {
    title: 'Data Rights (DSAR)',
    component: (
      <AdminLayout>
        <Dsar />
      </AdminLayout>
    ),
  };
}

export default action;
